export default {
  BANKER_BLOCK_ID: 100
};